"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.form.knowledge.show': 'Mostrar entradas de conocimiento',
    'avatar.form.knowledge.label': 'Entradas de Base de Conocimientos',
    'avatar.form.knowledge.search_placeholder': 'Buscar entradas de conocimiento...',
    'avatar.form.knowledge.add': 'Agregar Nuevo Conocimiento',
    'avatar.form.knowledge.fullscan': 'Escaneo completo del documento',
    'avatar.form.title.edit': 'Editar Avatar',
    'avatar.form.title.add': 'Agregar Avatar',
    'avatar.form.back': 'Atrás',
    'avatar.form.name.label': 'Nombre',
    'avatar.form.name.placeholder': 'Nombre del avatar',
    'avatar.form.gender.label': 'Género',
    'avatar.form.gender.placeholder': 'Seleccionar género',
    'avatar.form.gender.none': 'Ninguno',
    'avatar.form.gender.male': 'Masculino',
    'avatar.form.gender.female': 'Femenino',
    'avatar.form.age.label': 'Edad',
    'avatar.form.age.placeholder': 'Edad',
    'avatar.form.voice.label': 'Voz',
    'avatar.form.voice.placeholder': '-- Seleccionar Voz --',
    'avatar.form.voice.male': 'Voces Masculinas',
    'avatar.form.voice.female': 'Voces Femeninas',
    'avatar.form.logo.label': 'Imagen del avatar',
    'avatar.form.logo.placeholder': 'Enviar imagen del avatar',
    'avatar.form.instructionFile.label': 'Archivo de Instrucciones',
    'avatar.form.instructionFile.placeholder': 'Subir archivo de instrucciones',
    'avatar.form.instructions.title': 'Instrucciones',
    'avatar.form.instructions.description': 'Gestione entradas de instrucciones que guiarán el comportamiento del avatar. Cada entrada requiere un archivo adjunto y también puede tener notas y un prompt.',
    'avatar.form.error.instruction_file_required': 'Cada entrada de instrucción debe tener un archivo adjunto.',
    'avatar.form.instructions.add': 'Agregar instrucción',
    'avatar.form.instructions.empty': 'No hay entradas de instrucciones. Haga clic en "Agregar instrucción" para crear una.',
    'avatar.form.instructions.untitled': 'Capa sin nombre',
    'avatar.form.instructions.layer.label': 'Capa',
    'avatar.form.instructions.layer.placeholder': 'Ingrese nombre de capa',
    'avatar.form.instructions.notes.label': 'Notas',
    'avatar.form.instructions.notes.placeholder': 'Ingrese notas de instrucción',
    'avatar.form.instructions.prompt.label': 'Prompt de instrucción',
    'avatar.form.instructions.prompt.placeholder': 'Ingrese prompt de instrucción',
    'avatar.form.instructions.file.label': 'Archivo de instrucción',
    'avatar.form.instructions.isPublic.label': 'Pública (incluida en webhooks)',
    'avatar.form.instructions.file.placeholder': 'Subir archivo de instrucción',
    'avatar.form.instructions.files.label': 'Archivos de instrucciones',
    'avatar.form.instructions.files.placeholder': 'Subir archivos de instrucciones',
    'avatar.form.instructions.versions.title': 'Historial de versiones',
    'avatar.form.instructions.versions.show': 'Mostrar historial de versiones',
    'avatar.form.instructions.versions.hide': 'Ocultar historial de versiones',
    'avatar.form.instructions.versions.empty': 'No hay versiones anteriores disponibles.',
    'avatar.form.instructions.versions.restore': 'Restaurar',
    'avatar.form.instructions.versions.restore_confirm': '¿Estás seguro de que quieres restaurar esta versión? Los cambios actuales se sobrescribirán.',
    'avatar.form.description.label': 'Descripción',
    'avatar.form.description.placeholder': 'Descripción',
    'avatar.form.model.label': 'Modelo',
    'avatar.form.model.placeholder': 'Seleccionar modelo',
    'avatar.form.knowledge.placeholder': 'Seleccionar entradas de conocimiento',
    'avatar.form.submit.update': 'Actualizar Avatar',
    'avatar.form.submit.create': 'Crear Avatar',
    'avatar.form.submit.saveAndReturn.update': 'Guardar Avatar y volver a la lista',
    'avatar.form.submit.saveAndReturn.create': 'Crear Avatar y volver a la lista',
    'avatar.form.tab.configuration': 'Configuración',
    'avatar.form.tab.knowledge': 'Base de Conocimiento',
    'avatar.form.tab.instructions': 'Instrucciones',
    'avatar.form.tab.tools': 'Herramientas',
    'avatar.form.tab.webhooks': 'Webhooks',
    'avatar.form.tab.lexicon': 'Léxico',
    'avatar.form.tab.apiTools': 'Herramientas API',
    'avatar.form.timed.label': 'Habilitar disponibilidad basada en tiempo',
    'avatar.form.timed.help': 'Restringir cuándo este avatar está disponible',
    'avatar.form.startTime.label': 'Disponible desde',
    'avatar.form.startTime.placeholder': 'Seleccionar fecha de inicio',
    'avatar.form.endTime.label': 'Disponible hasta',
    'avatar.form.endTime.placeholder': 'Seleccionar fecha de fin',
    'avatar.form.webhooks.config.title': 'Configuración de Webhooks',
    'avatar.form.webhooks.config.description': 'Configurar ajustes de autorización para todos los endpoints de webhooks',
    'avatar.form.webhooks.config.authHeader.label': 'Cabecera de Autorización',
    'avatar.form.webhooks.config.authHeader.placeholder': 'ej. Authorization',
    'avatar.form.webhooks.config.authKey.label': 'Clave de Autorización',
    'avatar.form.webhooks.config.authKey.placeholder': 'Token Bearer o clave API',
    'avatar.form.webhooks.definitions.title': 'Definiciones de Webhooks',
    'avatar.form.webhooks.definitions.add': 'Añadir Webhook',
    'avatar.form.webhooks.definitions.empty': 'No hay definiciones de webhook configuradas. Haga clic en "Añadir Webhook" para crear una.',
    'avatar.form.webhooks.definitions.untitled': 'Webhook Sin Título',
    'avatar.form.webhooks.definitions.name.label': 'Nombre del Webhook',
    'avatar.form.webhooks.definitions.name.placeholder': 'Introducir nombre del webhook',
    'avatar.form.webhooks.definitions.address.label': 'URL del Webhook',
    'avatar.form.webhooks.definitions.address.placeholder': 'https://su-endpoint.com/webhook',
    'avatar.form.webhooks.definitions.eventType.label': 'Tipo de Evento',
    'avatar.form.webhooks.definitions.cronInterval.label': 'Intervalo Cron',
    'avatar.form.webhooks.definitions.cronInterval.placeholder': '*/30 * * * *',
    'avatar.form.webhooks.definitions.cronInterval.help': 'Expresión cron (ej. */30 * * * * = cada 30 minutos)',
    'avatar.form.webhooks.definitions.cronEnabled.label': 'Activar Cron',
    'avatar.form.webhooks.definitions.active.label': 'Activo',
    'avatar.form.webhooks.definitions.authEnabled.label': 'Habilitar Autorización',
    'avatar.form.webhooks.definitions.authHeader.label': 'Cabecera de Autorización',
    'avatar.form.webhooks.definitions.authHeader.placeholder': 'ej. Authorization',
    'avatar.form.webhooks.definitions.authKey.label': 'Clave de Autorización',
    'avatar.form.webhooks.definitions.authKey.placeholder': 'Token Bearer o clave API',
    'avatar.form.webhooks.payload.title': 'Ejemplo de Carga Útil',
    'avatar.form.webhooks.payload.subtitle': 'Ejemplo de carga útil JSON para este tipo de evento webhook',
    'avatar.form.webhooks.payload.description': 'Esta es la estructura de los datos JSON que se enviarán a tu endpoint webhook.',
    'avatar.form.lexicon.title': 'Entradas del Léxico',
    'avatar.form.lexicon.add': 'Añadir Entrada',
    'avatar.form.lexicon.empty': 'No hay entradas de léxico configuradas. Haga clic en "Añadir Entrada" para crear una.',
    'avatar.form.lexicon.untitled': 'Entrada Sin Título',
    'avatar.form.lexicon.hidden': 'Oculto',
    'avatar.form.lexicon.label.label': 'Etiqueta',
    'avatar.form.lexicon.label.placeholder': 'Ingrese término o palabra',
    'avatar.form.lexicon.value.label': 'Definición',
    'avatar.form.lexicon.value.placeholder': 'Ingrese definición o explicación',
    'avatar.form.lexicon.hidden.label': 'Oculto',
    'avatar.form.lexicon.hidden.help': 'Cuando esté habilitado, esta entrada no será visible para los usuarios pero será utilizada por el avatar para comprender',
    'avatar.form.apiTools.title': 'Herramientas API',
    'avatar.form.apiTools.description': 'Configure los endpoints de API externos que la IA puede llamar durante las conversaciones',
    'avatar.form.apiTools.enabled.label': 'Habilitar herramientas API',
    'avatar.form.apiTools.enabled.help': 'Permitir que el avatar realice llamadas a endpoints de API externos',
    'avatar.form.apiTools.list.title': 'Endpoints API',
    'avatar.form.apiTools.add': 'Agregar Endpoint',
    'avatar.form.apiTools.empty': 'No hay endpoints API configurados. Haga clic en "Agregar Endpoint" para crear uno.',
    'avatar.form.apiTools.untitled': 'Endpoint Sin Título',
    'avatar.form.apiTools.name.label': 'Nombre',
    'avatar.form.apiTools.name.placeholder': 'Ingrese nombre del endpoint',
    'avatar.form.apiTools.endpoint.label': 'URL del Endpoint',
    'avatar.form.apiTools.endpoint.placeholder': 'https://api.example.com/endpoint',
    'avatar.form.apiTools.method.label': 'Método',
    'avatar.form.apiTools.description.label': 'Descripción',
    'avatar.form.apiTools.description.placeholder': 'Describa qué hace este endpoint de API',
    'avatar.form.apiTools.description.help': 'Una descripción ayuda a la IA a entender cuándo y cómo usar este endpoint',
    'avatar.form.apiTools.authEnabled.label': 'Habilitar Autorización',
    'avatar.form.apiTools.authHeader.label': 'Header de Autorización',
    'avatar.form.apiTools.authHeader.placeholder': 'ej. Authorization',
    'avatar.form.apiTools.authKey.label': 'Clave de Autorización',
    'avatar.form.apiTools.authKey.placeholder': 'Token Bearer o clave API',
    'avatar.form.apiTools.authKey.toggle': 'Mostrar/Ocultar clave',
    'avatar.form.apiTools.payloadFields.title': 'Campos del Payload',
    'avatar.form.apiTools.payloadFields.add': 'Agregar Campo',
    'avatar.form.apiTools.payloadFields.description': 'Defina los campos que la IA completará al llamar a este endpoint',
    'avatar.form.apiTools.payloadFields.empty': 'No hay campos de payload definidos. Haga clic en "Agregar Campo" para crear uno.',
    'avatar.form.apiTools.payloadFields.name.label': 'Nombre del Campo',
    'avatar.form.apiTools.payloadFields.name.placeholder': 'ej. query',
    'avatar.form.apiTools.payloadFields.desc.label': 'Descripción del Campo',
    'avatar.form.apiTools.payloadFields.desc.placeholder': 'Describa para qué sirve este campo para que la IA sepa cómo completarlo',
    'avatar.form.apiTools.payloadFields.type.label': 'Tipo',
    'avatar.form.apiTools.payloadFields.optional.label': 'Opcional',
    'avatar.form.tools.title': 'Herramientas Disponibles',
    'avatar.form.tools.description': 'Selecciona qué herramientas puede usar este avatar durante las conversaciones',
    'avatar.form.error.load_failed': 'Error al cargar el avatar',
    'avatar.form.error.model_required': 'El modelo es requerido',
    'avatar.form.error.action_failed': 'Acción fallida',
    'avatar.form.error.general_error': 'Ocurrió un error',
    'avatar.form.action.updated': 'actualizado',
    'avatar.form.action.created': 'creado',
    'avatar.form.action.update': 'actualizar',
    'avatar.form.action.create': 'crear',
    'avatar.form.success.updated': 'Avatar actualizado exitosamente',
    'avatar.form.success.action_completed': 'Acción del avatar completada exitosamente',
};
